import type { IconNode } from '../types';

/**
 * @name layout-grid-move-horizontal
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSI3IiB4PSIzIiB5PSIzIiByeD0iMSIgLz4KICA8cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSI3IiB4PSIxNCIgeT0iMyIgcng9IjEiIC8+CiAgPHBhdGggZD0ibTcgMTQtNCA0IDQgNCIgLz4KICA8cGF0aCBkPSJNMjEgMThIMyIgLz4KICA8cGF0aCBkPSJtMTcgMTQgNCA0LTQgNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/layout-grid-move-horizontal
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const layoutGridMoveHorizontal: IconNode = [
  ['rect', { width: '7', height: '7', x: '3', y: '3', rx: '1', key: '1g98yp' }],
  ['rect', { width: '7', height: '7', x: '14', y: '3', rx: '1', key: '6d4xhi' }],
  ['path', { d: 'm7 14-4 4 4 4', key: '1os4wb' }],
  ['path', { d: 'M21 18H3', key: 'x8zd2e' }],
  ['path', { d: 'm17 14 4 4-4 4', key: 'prm0ft' }],
];

export default layoutGridMoveHorizontal;
